
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/notice",
      function () {
        return require("private-next-pages/support/notice/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/notice"])
      });
    }
  